import { toast } from '@/components/ui/use-toast';

export const notify = {
  success: (title: string, description?: string) => {
    toast({
      title,
      description,
      duration: 4000,
    });
  },
  
  error: (title: string, description?: string) => {
    toast({
      title,
      description,
      variant: 'destructive',
      duration: 6000,
    });
  },
  
  warning: (title: string, description?: string) => {
    toast({
      title,
      description,
      duration: 5000,
    });
  },
  
  info: (title: string, description?: string) => {
    toast({
      title,
      description,
      duration: 4000,
    });
  },
  
  loading: (title: string, description?: string) => {
    const t = toast({
      title,
      description,
      // Long duration; caller can dismiss via returned handle if needed
      duration: 60000,
    });
    return t.id;
  },
  
  dismiss: (_toastId?: string | number) => {
    // Shadcn toast does not expose a global dismiss by id without hook context.
    // Existing codebase does not use notify.dismiss; no-op for compatibility.
  }
};